import { dateRangePickerDayClasses } from "@mui/x-date-pickers-pro";
const borderRadius = '4px';
const endBorderStyle = {
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius
};
const startBorderStyle = {
    borderTopLeftRadius: borderRadius,
    borderBottomLeftRadius: borderRadius
};
const MuiDateRangePickerDay = {
    styleOverrides: {
        root: {
            borderRadius: 0,
            '&:first-of-type': {
                ...startBorderStyle,
                [`.${dateRangePickerDayClasses.rangeIntervalDayPreview}`]: {
                    ...startBorderStyle
                }
            },
            '&:last-of-type': {
                ...endBorderStyle,
                [`.${dateRangePickerDayClasses.rangeIntervalDayPreview}`]: {
                    ...endBorderStyle
                }
            },
            [`&.${dateRangePickerDayClasses.firstVisibleCell}`]: {
                ...startBorderStyle
            },
            [`&.${dateRangePickerDayClasses.lastVisibleCell}`]: {
                ...endBorderStyle
            }
        },
        day: ({ theme })=>({
                borderRadius: 0,
                width: '36px',
                height: '24px',
                '&:not(.Mui-selected)': {
                    borderRadius,
                    borderColor: theme.palette.primary.main,
                    [`&.${dateRangePickerDayClasses.dayOutsideRangeInterval}:hover`]: {
                        borderColor: 'transparent',
                        backgroundColor: theme.palette.divider
                    }
                },
                [`&.Mui-selected.${dateRangePickerDayClasses.dayOutsideRangeInterval}`]: {
                    borderRadius,
                    background: theme.palette.primary.main
                }
            }),
        outsideCurrentMonth: {
            [`.${dateRangePickerDayClasses.rangeIntervalPreview}`]: {
                background: 'transparent'
            }
        },
        rangeIntervalDayPreviewStart: {
            ...startBorderStyle
        },
        rangeIntervalDayPreviewEnd: {
            ...endBorderStyle
        },
        rangeIntervalDayHighlightStart: ({ theme })=>({
                [`.${dateRangePickerDayClasses.rangeIntervalPreview}`]: {
                    background: theme.palette.primary.main,
                    ...startBorderStyle
                },
                [`.${dateRangePickerDayClasses.day}`]: {
                    ...startBorderStyle
                }
            }),
        rangeIntervalDayHighlightEnd: ({ theme })=>({
                [`.${dateRangePickerDayClasses.rangeIntervalPreview}`]: {
                    background: theme.palette.primary.main,
                    ...endBorderStyle
                },
                [`.${dateRangePickerDayClasses.day}`]: {
                    ...endBorderStyle
                }
            })
    }
};
export { MuiDateRangePickerDay };

//# sourceMappingURL=date-range-picker-day-overrides.js.map